import { render, staticRenderFns } from "./OutdatedLessonsNotice.vue?vue&type=template&id=11e1b526&scoped=true"
import script from "./OutdatedLessonsNotice.vue?vue&type=script&lang=js"
export * from "./OutdatedLessonsNotice.vue?vue&type=script&lang=js"
import style0 from "./OutdatedLessonsNotice.vue?vue&type=style&index=0&id=11e1b526&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e1b526",
  null
  
)

export default component.exports